import {
    Panel, Button,
} from 'appkit-react';
import { Row, Col } from 'react-bootstrap';

const getSourceFileName = (successData, exceptionData) => {
    const isSuccessDataAvailable = successData && successData.length > 0;

    const isExceptionDataAvailable = exceptionData && exceptionData.length > 0;
    if (isSuccessDataAvailable) {
        return successData[0].sourceFileName;
    }
    return isExceptionDataAvailable ? exceptionData[0].sourceFileName : '';
};

const getTargetFileName = (successData, exceptionData) => {
    const isSuccessDataAvailable = successData && successData.length > 0;

    const isExceptionDataAvailable = exceptionData && exceptionData.length > 0;
    if (isSuccessDataAvailable) {
        return successData[0].targetFileName;
    }
    return isExceptionDataAvailable ? exceptionData[0].targetFileName : '';
};

const getSourceGroupBy = (successData, exceptionData, nodeConfig) => {
    const isNodeConfigSrcGrpByAvailable = nodeConfig && nodeConfig.sourceGroupBy
    && nodeConfig.sourceGroupBy.length > 0;
    const dataAvailable = (successData.length > 0 || exceptionData.length > 0)
    && isNodeConfigSrcGrpByAvailable;
    return dataAvailable ? nodeConfig.sourceGroupBy.join(',') : '';
};

const getTargetGroupBy = (successData, exceptionData, nodeConfig) => {
    const isNodeConfigTrgtGrpByAvailable = nodeConfig && nodeConfig.targetGroupBy
    && nodeConfig.targetGroupBy.length > 0;
    const dataAvailable = (successData.length > 0 || exceptionData.length > 0) && isNodeConfigTrgtGrpByAvailable;
    return dataAvailable ? nodeConfig.targetGroupBy.join(',') : '';
};
const DataStopDetails = ({
    downloadFile, isFileDownloading, successData, exceptionData, nodeConfig,
}) => (
    <Panel
        style={{ marginTop: '1.5rem' }}
        title="DATA STOP DETAILS"
        className="a-increase-child-color-level-by-1"
        renderRight={() => (
            <>
                <span>
                    <Button
                        style={{ marginLeft: '2rem', width: 'max-content' }}
                        className="a-btn a-btn-secondary a-btn-lg"
                        kind="secondary"
                        size="lg"
                        onClick={() => downloadFile()}
                        isLoading={isFileDownloading}
                    >
                        DOWNLOAD
                    </Button>
                </span>
            </>
        )}
    >
        <Row style={{ paddingBottom: '2rem' }}>
            <Col md={6}>
                <Row className="true-comply-data-recon-result-row_margin">
                    <Col md={4} className="a-h6">
                        Source file
                        <span
                            className="true-comply-data-recon-result_label"
                        >
                            :
                        </span>
                    </Col>
                    <Col md={8}>
                        {getSourceFileName(successData, exceptionData)}
                    </Col>
                </Row>
                <Row className="true-comply-data-recon-result-row_margin">
                    <Col md={4} className="a-h6">
                        Source Column
                        <span className="true-comply-data-recon-result_label">:</span>
                    </Col>
                    <Col md={8}>
                        {nodeConfig?.sourceColumns[0] || ''}
                    </Col>
                </Row>
                {nodeConfig?.sourceGroupBy && nodeConfig?.sourceGroupBy.length > 0 && (
                    <Row className="true-comply-data-recon-result-row_margin">
                        <Col md={4} className="a-h6">
                            Source Group By
                            <span className="true-comply-data-recon-result_label">:</span>
                        </Col>
                        <Col md={8}>
                            {getSourceGroupBy(successData, exceptionData, nodeConfig)}
                        </Col>
                    </Row>
                )}
                <Row className="true-comply-data-recon-result-row_margin">
                    <Col md={4} className="a-h6">
                        Operation
                        <span className="true-comply-data-recon-result_label">:</span>
                    </Col>
                    <Col md={8}>
                        {nodeConfig?.operation || ''}
                    </Col>
                </Row>
            </Col>
            <Col md={6}>
                <Row className="true-comply-data-recon-result-row_margin">
                    <Col md={4} className="a-h6">
                        Target file
                        <span className="true-comply-data-recon-result_label">:</span>
                    </Col>
                    <Col md={8}>
                        {getTargetFileName(successData, exceptionData)}
                    </Col>
                </Row>
                <Row className="true-comply-data-recon-result-row_margin">
                    <Col md={4} className="a-h6">
                        Target Column
                        <span className="true-comply-data-recon-result_label">:</span>
                    </Col>
                    <Col md={4}>
                        {nodeConfig?.targetColumns[0] || ''}
                    </Col>
                </Row>
                {nodeConfig?.targetGroupBy && nodeConfig?.targetGroupBy.length > 0 && (
                    <Row className="true-comply-data-recon-result-row_margin">
                        <Col md={4} className="a-h6">
                            Target Group By
                            <span className="true-comply-data-recon-result_label">:</span>
                        </Col>
                        <Col md={8}>
                            {getTargetGroupBy(successData, exceptionData, nodeConfig)}
                        </Col>
                    </Row>
                )}
                {nodeConfig?.subOperation && (
                    <Row className="true-comply-data-recon-result-row_margin">
                        <Col md={4} className="a-h6">
                            Sub Operation
                            <span className="true-comply-data-recon-result_label">:</span>
                        </Col>
                        <Col md={8}>
                            {nodeConfig?.subOperation}
                        </Col>
                    </Row>
                )}
            </Col>
        </Row>
    </Panel>
);

export default DataStopDetails;
